import {
  SEASONS_LIST_LOADING,
  SEASONS_LIST_SUCCESS,
  SEASONS_LIST_ERROR,
} from "../../../constant/actionTypes";

const seasonListReducer = (state = {}, action) => {
  switch (action.type) {
    case SEASONS_LIST_LOADING: {
      let obj = {
        loading: true,
      };
      return obj;
    }
    case SEASONS_LIST_SUCCESS: {
      let obj = {
        loading: false,
        data: action.response,
      };
      return obj;
    }
    case SEASONS_LIST_ERROR: {
      let obj = {
        loading: false,
        status: action.response,
      };
      return obj;
    }
    default:
      return state;
  }
};

export default seasonListReducer;
